import { fetchNotification, fetchNotifications } from '../queries/notifications.queries'

import { skipToken, useQuery } from '@tanstack/react-query'

export const useNotifications = () =>
  useQuery({
    queryKey: ['notifications'],
    queryFn: fetchNotifications,
  })

export const useNotification = (id?: number) =>
  useQuery({
    queryKey: ['notification', id],
    queryFn: id
      ? () => {
          if (Number.isNaN(id)) {
            return null
          }
          return fetchNotification(id)
        }
      : skipToken,
  })
